export default "__VITE_ASSET__a414b4c8__"